// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.copyText {
  margin-bottom: 0;
  line-height: 1;
}
.copyText :global .ant-typography-copy svg {
  display: block;
}
`, "",{"version":3,"sources":["webpack://./src/components/CopyText/style.less"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,cAAA;AACF;AAHA;EAOQ,cAAA;AADR","sourcesContent":[".copyText {\n  margin-bottom: 0;\n  line-height: 1;\n\n  :global {\n    .ant-typography-copy {\n      svg {\n        display: block;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
